import React from "react";
import { Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { customIconCircleStyles } from "./styles";

interface IProps {
  index: number;
  activeStep: number;
}

const StepperIcon: React.FC<IProps> = ({ index, activeStep }) => {
  const isCompleted = index < activeStep;

  return (
    <Box className="custom-icon" sx={customIconCircleStyles}>
      {isCompleted ? (
        <CheckIcon color="inherit" />
      ) : (
        <Typography
          className="custom-icon-text"
          variant="subtitle1"
          color="inherit"
          fontWeight={600}
          fontSize={{ xs: "1rem", md: "1rem" }}
        >
          0{index + 1}
        </Typography>
      )}
    </Box>
  );
};

export default StepperIcon;
